import { ImgHTMLAttributes } from 'react'
import { config } from '../../../config'
import { resolveCarrierLogo } from './utils'

export interface CarrierLogoProps extends ImgHTMLAttributes<HTMLImageElement> {
  name: string | null
}

export const CarrierLogo = ({ name, ...rest }: CarrierLogoProps) => {
  const src = resolveCarrierLogo(name)

  return (
    <img
      alt={name || config.genericCarrierLogo}
      onError={({ currentTarget }) => {
        currentTarget.onerror = null
        currentTarget.src = `${config.cdn}/${config.genericCarrierLogo}`
      }}
      src={src}
      {...rest}
    />
  )
}
